import { render } from "./Roles.vue?vue&type=template&id=16c984ac"
import script from "./Roles.vue?vue&type=script&lang=js"
export * from "./Roles.vue?vue&type=script&lang=js"
script.render = render

export default script